import React, { useState } from "react";
import { withRouter } from 'react-router-dom';
import { Text, Image } from "@sitecore-jss/sitecore-jss-react";
import { RoutableLink } from '../../react/RoutableLink';
import { Sizes, Colors } from '../../ts/enums';
import css from './index.module.scss';

const ToggleSearchFlyout = () => {
    let currentState = document.body.getAttribute('data-searchopen') === 'true';
    // @ts-ignore
    document.body.setAttribute('data-searchopen', !currentState); 
    document.body.setAttribute('data-infodropdownisopen', 'true'); 

    //adjust the aria-expanded attribute for the search icon button
    document.getElementById("searchFlyoutIcon").setAttribute('aria-expanded',Boolean(!currentState).toString());

    // Update tabindexes for keyboard tabbing, -1 is 'not tabbable' when search form is closed, 0 is 'tabbable' when open
    let allSearchActions = document.body.querySelectorAll(`div[class*='GeneralHeader_searchFlyout'] *[tabindex]`);
    allSearchActions.forEach(function (action) {
        action.setAttribute('tabIndex', currentState ? '-1' : '0');
    });
    document.addEventListener('keydown', handleEscKey);
}

const ToggleMobileNav = () => {
    ToggleSearchFlyout();
    let header = document.querySelector('header[data-mobilenavisopen');
    let currentState = header.getAttribute('data-mobilenavisopen') === 'true';
    // @ts-ignore
    header.setAttribute('data-mobilenavisopen', !currentState);

    let button = document.querySelector(`button.${css.mobileNavToggle}`);
    button.setAttribute('aria-expanded', `${!currentState}`);

    if (typeof window !== 'undefined' && window.innerWidth <= 900) {
      let currentBodyState = document.body.getAttribute('data-mobilenavopen') === 'true';
      // @ts-ignore
      document.body.setAttribute('data-mobilenavopen', !currentBodyState);
    }
    document.addEventListener('keydown', handleEscKey);
  }

  const handleEscKey = (e) => {
    if (e.key === 'Escape' && e.target.closest('[data-mobilenavopen]') ){
        document.querySelector('*[data-mobilenavisopen]').setAttribute('data-mobilenavisopen', 'false');
      ;
    } if(e.key === 'Escape') {
        document.querySelector('*[data-searchopen]').setAttribute('data-searchopen', 'false');
    }
  };
  
const keyToCloseDropdown = (e) => {
    // Escape || Tab outside dropdown
    if (e.which === 27 || (e.which === 9 && e.target.closest('[data-infodropdownisopen]') === null)) {
        ToggleInfoDropdown();
    }
}

const clickToCloseDropdown = (e) => {
    if (!e.target.classList.contains(css.infoDropdownButton)) {
        ToggleInfoDropdown();
    }
}

const ToggleInfoDropdown = () => {
    let dropdownContainer = document.querySelector('*[data-infodropdownisopen');
    let currentState = dropdownContainer.getAttribute('data-infodropdownisopen') === 'true';
    // @ts-ignore
    dropdownContainer.setAttribute('data-infodropdownisopen', !currentState);
    dropdownContainer.setAttribute('aria-expanded', `${!currentState}`);

    if (!currentState) {
        // Is open
        document.body.addEventListener('click', clickToCloseDropdown);
        document.body.addEventListener('keyup', keyToCloseDropdown);
        
    }
    else {
        // Is closed
        document.body.removeEventListener('click', clickToCloseDropdown);
        document.body.removeEventListener('keyup', keyToCloseDropdown);
    }
}


const GeneralBrandbar = ({
    phoenixLink, 
    phoenixCaption,
    phoenix, 
    utilityNavLinks, 
    seachIcon, 
    searchPageLink,
    globalSearchboxPlaceholderText,
    history,
    ResetNavHandler
    }) => {
    
    // state variable for search query 
    const [searchQuery, setSearchQuery] = useState('');

    const handleSearch = () => {
        if (searchPageLink) {
            history.push(`${searchPageLink}#q=${searchQuery}`);
        }
    }

    const handleChange = (e) => {
        setSearchQuery(e.target.value)
    }
  
    return (
      <nav id="brandbar" className={css.container} aria-label="utility">
        <div className={css.brandbarInner}>
          {/* The phoenix */}
         
          <RoutableLink field={phoenixLink} className={css.phoenixLink} editable={false}>
            <Image className={css.phoenix} field={phoenix} editable={false} />
            <span className={css.phoenixCaption}>{phoenixCaption?.value}</span>
          </RoutableLink>
          

          {/* The Links */}
          <LinkContainer links={utilityNavLinks} ResetNavHandler={ResetNavHandler} />

          {/* Search */}
          {
              seachIcon 
              ? <button aria-label='Search'  aria-controls='searchFlyout' aria-expanded='false' id='searchFlyoutIcon' className={css.searchButton} onClick={() => ToggleSearchFlyout()}>
                  <i className={`fa fa-${seachIcon}`} />
              </button>
              : null
          }
                
       
         <button className={css.mobileNavToggle} onClick={ToggleMobileNav} aria-label="Show main menu" aria-expanded={false} />
      
      
          </div>
      </nav>
    )
  }
  

  // Takes a list of links and spits out left/right container markup
const LinkContainer = ({ links, ResetNavHandler }) => {
    return (
        <ul className={css.linkContainer}>
            {
                links?.map((link, index) => (
                    (link?.fields?.title?.value && link?.fields?.children?.length > 0) ?
                        // Dropdown
                        <li className={`${css.infoDropdownContainer} ${css.linkListItem}`}
                            data-infodropdownisopen={false}
                            aria-expanded={false}
                            key={`brandBar-link-dropdown-${index}`}>
                            <Text className={css.infoDropdownButton}
                                field={link.fields.title}
                                tag='button'
                                onClick={ToggleInfoDropdown}
                                 />
                            <ul className={css.infoDropdownList}>
                                {
                                    link.fields.children?.map((dropdownLink, index) =>
                                        (dropdownLink?.fields?.link?.value?.href && dropdownLink?.fields?.linkText?.value) &&
                                        <li className={css.infoDropdownListItem} key={`infodropdown-${index}`}>
                                            <RoutableLink field={dropdownLink.fields.link}
                                                data-chevron={true} data-size={Sizes.SMALL}
                                                data-color={Colors.GREY}
                                                className={css.infoDropdownLink}>
                                                <Text field={dropdownLink.fields.linkText} />
                                            </RoutableLink>
                                        </li>
                                    )
                                }
                            </ul>
                        </li>
                        :
                        // Regular link
                        (link?.fields?.link?.value?.href && link?.fields?.linkText?.value) &&
                        <li className={css.linkListItem} key={`brandBar-link-dropdown-${index}`}>
                            <RoutableLink field={link.fields.link}
                                onClick={ResetNavHandler}
                                className={`${css.brandBarLink}${link.fields.highlight?.value === true ? ` ${css.linkHighlight}` : ''}`}
                                key={`brandBar-link-${index}`}>
                                <Text field={link.fields.linkText} />
                            </RoutableLink>
                        </li>
                ))
            }
        </ul>
    )
  }

  export default withRouter(GeneralBrandbar);